exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-archive-news[data-v-eadc81b6]{margin-top:70px}@media print, screen and (max-width: 769px){.v-archive-news[data-v-eadc81b6]{margin-top:40px}}\n", ""]);
